import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import cnaeSelector from "../store/cnae.selectors";
import cnaeActions from "../store/cnae.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import * as messages from "@/modules/common/app/helpers/common.messages";
import formActions from "@common/store/form/form.actions";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "Deca.Cnaes",
      applySearchOnLoad: true
    };

    const columns = [
      {
        fieldName: "Código",
        dataName: "CodigoString",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Descrição",
        dataName: "Descricao",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Principal",
        dataName: "Principal",
        show: true,
        array: typeArray.tipoSimNaoInt,
        type: "lista",
        arrayType: "text",
        removeFilter: true
      }
    ];

    const order = [
      { fieldName: "Código", dataName: "CodigoString", order: "A" }
    ];

    const actions = [
      {
        title: "Tornar principal",
        icon: "fas fa-check",
        onClick: async dataItem => {
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3")
            _showError(
              "Este registro não pode ser modificado durante o processo de Encerramento."
            );
          else if (
            SituacaoSolicitacao != "Aguardando Avaliação" &&
            SituacaoSolicitacao != 1 &&
            SituacaoSolicitacao != 2
          )
            _showError("Este registro não pode ser modificado.");
          else await this.props.cnaeActions.mainSagaCnae(dataItem);
        }
      },
      {
        type: "delete",
        onClick: async dataItem => {
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;

          if (TipoSolicitacao == "3")
            _showError(
              "Este registro não pode ser excluído durante o processo de Encerramento."
            );
          else if (
            SituacaoSolicitacao != "Aguardando Avaliação" &&
            SituacaoSolicitacao != 1 &&
            SituacaoSolicitacao != 2
          ) {
            console.log(SituacaoSolicitacao);
            _showError("Este registro não pode ser modificado.");
          } else {
            const result = await _alert.confirm(
              messages.CONFIRMA_DELETE,
              "Remover Registro Selecionado"
            );
            if (result) this.props.cnaeActions.deleteSagaCnae(dataItem);
          }
        }
      }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  render() {
    const { cnae } = this.props.cnaeSelector;
    const { cnaes } = cnae;
    const { isView } = this.props;
    if (isView) this.config.actions = [];

    return <StaticGrid {...this.config} itens={cnaes.asMutable()}></StaticGrid>;
  }
}

export default connect({
  actions: {
    cnaeActions
  },
  selectors: {
    solicitacaoSelector,
    cnaeSelector
  }
})(Container);
